// GENERATED by tools/build/gen-icon-data.mjs (npm run gen:icon-data) from the PHP catalogs.
// SpecialIcon — range / speed / sphere / terrain icons (icon-only).
import type { IconMap } from '../types';

export const SPECIAL_ICONS: IconMap = {
	"arcane": {
		"file": "arcane",
		"tooltip": "Arcane Sphere of Magic"
	},
	"divine": {
		"file": "divine",
		"tooltip": "Divine Sphere of Magic"
	},
	"primal": {
		"file": "primal",
		"tooltip": "Primal Sphere of Magic"
	},
	"range_close": {
		"file": "range_close",
		"tooltip": "Close (30)"
	},
	"range_far": {
		"file": "range_far",
		"tooltip": "Far (120)"
	},
	"range_near": {
		"file": "range_near",
		"tooltip": "Near (60)"
	},
	"range_object": {
		"file": "range_object",
		"tooltip": "Object"
	},
	"range_reach": {
		"file": "range_reach",
		"tooltip": "Reach"
	},
	"range_self": {
		"file": "range_self",
		"tooltip": "Self"
	},
	"range_unlimited": {
		"file": "range_unlimited",
		"tooltip": "Unlimited"
	},
	"range_very_far": {
		"file": "range_very_far",
		"tooltip": "Very Far (240)"
	},
	"speed_burrowing": {
		"file": "speed_burrowing",
		"tooltip": "Burrowing Speed"
	},
	"speed_climbing": {
		"file": "speed_climbing",
		"tooltip": "Climbing Speed"
	},
	"speed_flying": {
		"file": "speed_flying",
		"tooltip": "Flying Speed"
	},
	"speed_hovering": {
		"file": "speed_hovering",
		"tooltip": "Hovering Speed"
	},
	"speed_jumping": {
		"file": "speed_jumping",
		"tooltip": "Jumping Speed"
	},
	"speed_swimming": {
		"file": "speed_swimming",
		"tooltip": "Swimming Speed"
	},
	"speed_walking": {
		"file": "speed_walking",
		"tooltip": "Walking Speed"
	},
	"teleport": {
		"file": "teleport",
		"tooltip": "Teleport (ft)"
	},
	"terrain_type_difficult": {
		"file": "terrain_type_difficult",
		"tooltip": "Difficult Terrain"
	},
	"terrain_type_simple": {
		"file": "terrain_type_simple",
		"tooltip": "Simple Terrain"
	}
};
